import * as actionTypes from "./actionTypes";

const initialState = {
  data: [],
  summaryData: {},
  isLoading: false,
  gettingPreview: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_INTERVIEW_FEEDBACK:
      return { ...state, isLoading: true };
    case actionTypes.GET_INTERVIEW_FEEDBACK_FULFILLED:
      return {
        ...state,
        isLoading: false,
        summaryData: action.payload.data,
      };
    case actionTypes.GET_INTERVIEW_FEEDBACK_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.PREVIEW_INTERVIEW_FEEDBACK:
      return { ...state, gettingPreview: true };
    case actionTypes.PREVIEW_INTERVIEW_FEEDBACK_FULFILLED:
      return {
        ...state,
        gettingPreview: false,
      };
    case actionTypes.PREVIEW_INTERVIEW_FEEDBACK_REJECTED:
      return { ...state, gettingPreview: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
